<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'ORDERS.MERCHANT_REFUND_LABEL' | translate }}</h3>
    </div>
  </div>
  <div
    *ngIf="refund"
    class="sp-width__full sp-margin__top-x2 sp-order-details-qinetic-refund__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'ORDERS.REFUND_ID_LABEL'"
      [content]="refund.refund_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'ORDERS.REFUND_STATUS_LABEL'"
      [content]="refund.status || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.REFUND_LABEL'"
      [content]="getFormattedNet(refund)"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.REFUND_CREATED_AT_LABEL'"
      [content]="(refund.created_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.REFUND_DATE_LABEL'"
      [content]="(refund.succeeded_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'ORDERS.REFUND_FAILED_AT_LABEL'"
      [content]="(refund.failed_at | date : 'short') ?? '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div
    *ngIf="!refund"
    class="sp-width__full sp-margin__top-x12 sp-padding__x4">
    <div class="sp-margin__bottom sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
    <p class="sp-text__center sp-color__primary">{{ 'ORDER_DETAILS.REFUND_NOT_FOUND_LABEL' | translate }}</p>
    <div class="sp-margin__top sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
  </div>
</div>
